import { defineNuxtPlugin } from '#app'
import DOMPurifyImport from 'dompurify'
import type { Config } from 'dompurify'

export default defineNuxtPlugin(async () => {
  let DOMPurify: typeof DOMPurifyImport
  
  if (import.meta.server) {
    const { JSDOM } = await import('jsdom')
    const window = new JSDOM('').window
    DOMPurify = DOMPurifyImport(window as any)
  } else {
    DOMPurify = DOMPurifyImport
  }

  const sanitizeHtml = (dirty: string, config?: Config) =>
    DOMPurify.sanitize(dirty, config)

  const sanitizeText = (dirty: string) =>
    DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
      FORBID_TAGS: ['script']
    })

  return {
    provide: {
      sanitizeHtml,
      sanitizeText
    }
  }
})
